<template>
  
  <div id="reserve-picker-dialog" class="ui modal reserve-picker-modal">

    <div class="ui header">
      Selecionar Reserva
    </div>

    <div class="content modal-content-scrolling">

      <form class="ui form">
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Unidade</label> 
            <input type="text" :value="quotation.customer.billBranch == '01' ? 'Itu' : 'Três Lagoas'" readonly="readonly">
          </div>
          <div class="twelve wide field">
            <label class="form-label">Cliente</label> 
            <input type="text" :value="quotation.customer.name" readonly="readonly">
          </div>
        </div>
      </form>   

      <div v-if="loading" class="m-t-30"><i class="spinner circle loading blue icon"></i> Carregando reservas...</div> 

      <div v-if="!loading && reserves.length == 0" class="ui label m-t-30">
        <i class="info circle icon"></i> Nenhuma reserva pendente para esse cliente
      </div>   

      <div v-if="!loading && reserves.length > 0" class="ui basic segment animated fadeIn">
        <table class="ui very basic selectable celled table">
          <thead class="desktop-only">
            <tr>
              <th>Número</th>
              <th>Produto</th>
              <th>Quantidade</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="reserve in reserves" class="clickable" @click="onSelectReserve(reserve)">
              <td>
                <i v-if="reserve.idQuotation" class="ban red icon"></i>
                <i v-else class="check circle green icon"></i>
                {{ reserve.id }}
              </td>
              <td>{{ reserve.balance.product.description + ' ' + reserve.balance.address }}</td>
              <td>{{ $formatInteger(reserve.balance.quantity) }}</td>
            </tr>
          </tbody>
        </table>
      </div>  

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
    </div>

  </div>  

</template>

<script>

  import OppBalanceService from "@/services/opp-balance-service"
  import Message from "@/utils/message"

  export default {
    
    data() {
      return {
        loading: true,
        reserves: [],
      }
    },

    props: ["quotation"],

    mounted() {

      $("#reserve-picker-dialog").modal({
        autofocus: false,
        onVisible: () => this.loadReserves(),
      })
    },

    beforeDestroy() {
      $(".reserve-picker-modal").remove()
    },

    methods: {

      show() {      
        this.loading = true  
        $("#reserve-picker-dialog").modal("show")
      },

      hide() {
        $("#reserve-picker-dialog").modal("hide")
      },

      async loadReserves() {

        this.loading = true

        try {

          let reserves = await OppBalanceService.searchReserves({
            branch: this.quotation.customer.billBranch,
            customerCode: this.quotation.customer.code,
            customerUnit: this.quotation.customer.unit,
            status: OppBalanceService.RESERVE_STATUS.WAITING,
          })

          reserves.forEach((reserve) => {
            if (this.reserveAdded(reserve))
              reserve.idQuotation = "this"
          })

          this.reserves = reserves.slice()

          this.loading = false
          
        } catch (error) {
          this.$errorHandler(error)  
        }
      },

      reserveAdded(reserve) {

        let added = false

        this.quotation.items.forEach((item) => {
          if (item.branchReserve == reserve.balance.branch.id && item.idReserve == reserve.id)
            added = true
        })

        return added 
      },

      onSelectReserve(reserve) {

        if (reserve.idQuotation) {
          Message.info("Reserva já associada a um orçamento")
          return
        }

        this.$emit("onSelectReserve", reserve)
        
        this.hide()
      },
    },
  }

</script>

